import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from 'src/app/doctors-station/doctors-station.constants';
import { DxauthService, UserinfoResponse } from 'src/app/dxauth.service';
import { FaviconSwitchComponent } from 'src/app/shared/components/base-reset-password/favicon-switch.component';
import { Auth0Service } from 'src/app/shared/services/auth0.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-account-integration',
  templateUrl: './account-integration.component.html',
  styleUrls: ['./account-integration.component.css', '../common/css/index.css'],
})
export class AccountIntegrationComponent
  extends FaviconSwitchComponent
  implements OnInit
{
  userinfo: UserinfoResponse;
  sessionStorageKey = 'account-integration-userinfo';
  isAgreed: boolean = false;
  isShowErrorMessage: boolean = false;
  constructor(private auth0: Auth0Service, private dxauth: DxauthService) {
    super();
    this.clientId = sessionStorage.getItem(
      sessionStorageKey.isAccountIntegrationClientId
    );
  }

  async ngOnInit() {
    // リロードなどをされた時に無駄にAPIを叩かないように、セッションストレージにキャッシュしておく
    const cachedUserinfo = sessionStorage.getItem(this.sessionStorageKey);
    if (cachedUserinfo) {
      this.userinfo = JSON.parse(cachedUserinfo);
      return;
    }
    // セッションが貼られていることを利用して
    const session = await this.auth0.checkLogin({
      redirectUri: environment.baseUri,
      scope: 'openid profile email',
    });
    if (!session.accessToken) {
      // セッションが存在しない場合にはいる。通常有りえない想定
      alert('invalid state');
      return;
    }
    this.userinfo = await this.dxauth.userinfo({
      accessToken: session.accessToken,
    });
    sessionStorage.setItem(
      this.sessionStorageKey,
      JSON.stringify(this.userinfo)
    );
  }

  clickLoginButton() {
    this.isShowErrorMessage = false;
    if (!this.isAgreed) {
      this.isShowErrorMessage = true;
      return;
    }
    sessionStorage.removeItem(sessionStorageKey.isAccountIntegrationClientId);
    location.href = '/?state=tmp&code=tmp';
  }
  get termsUrl() {
    return environment.apps[this.clientId]?.termUrl;
  }

  get privacyPolicyUrl() {
    return environment.apps[this.clientId]?.privacyUrl;
  }
}
